import { Component, OnInit } from '@angular/core';

import { Deslocamento } from "../shared/deslocamento.model";
import {deslocamentosModuleName, tiposDeslocamentos, statusDeslocamentos} from "../shared/data.service";
import { DeslocamentoApiService } from "../shared/deslocamento-api.service";
import { DeslocamentoNavigationService } from "../shared/deslocamento-navigation.service";
import { UtilService } from "../../../shared/services/util.service";
import {DeslocamentoService} from "../shared/deslocamento.service";
import {FuncionarioService} from "../../../recursos-humanos/funcionarios/funcionario.service";
import {funcionariosQueryComPessoa} from "../../../recursos-humanos/funcionarios/data.service";
import {FuncionarioApiService} from "../../../recursos-humanos/funcionarios/funcionario-api.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {UsuarioService} from "../../../recursos-humanos/usuarios/shared/usuario.service";
import {viagensModuleName} from "../../shared/data.service";

@Component({
    template: require('./deslocamento-list.component.html'),
    styles: [require('./deslocamento-list.component.css')]
})
export class DeslocamentoListComponent implements OnInit {
    list: Deslocamento[] = [];
    loading: boolean = true;
    showDisabled: boolean = false;
    deslocamentosModuleName: any = deslocamentosModuleName;
    module: any = viagensModuleName;

    funcionarioSearch: any = {};
    funcionarioSelectId: string = 'funcionario';
    funcionarioQuery: any = {};
    tipoSearch: any = {};
    tiposList: any[] = [];
    statusSearch: any = {};
    statusList: any[] = [];
    periodoSearch: any = {};
    periodosList: any[] = [];

    private isVisitor: any = false;

    constructor(
        private _deslocamentosApiService: DeslocamentoApiService,
        private _deslocamentoNavigationService: DeslocamentoNavigationService,
        private _deslocamentoService: DeslocamentoService,
        private _utilService: UtilService,
        private _usuarioService: UsuarioService,

        private _funcionarioService: FuncionarioService,
        private _funcionarioApiService: FuncionarioApiService,
        private _autocompleteService: AutoCompleteService
    ) { }

    ngOnInit() {
        this.isVisitor = this._usuarioService.checkIsVisitor();
        this.funcionarioQuery = this._utilService.cloneObject(funcionariosQueryComPessoa);

        this.getTipos();
        this.getStatus();
        this.clickClearSearch();

        let datePicker: any = $('.input-datepicker');
        const t: any = this;
        datePicker.datepicker({
            onSelect: function(e: any) {
                t.changeData();
            }
        });
    }

    clickNew() {
        this._deslocamentoNavigationService.goToNew();
    }

    changeData() {
        this.list = [];
        this.queryMovimentacoes();
    }

    changeTipo() {
        this.queryMovimentacoes();
    }

    changeStatus() {
        this.queryMovimentacoes();
    }

    clickClearSearch() {
        this.periodoSearch = this.periodosList[0];
        this.tipoSearch = this.tiposList[0];
        this.funcionarioSearch = {};
        let date:any = document.getElementById('data_saida');
        date.value = null;

        if (this.isVisitor) {
            this.statusSearch = this.statusList[0];
        } else {
            this.statusSearch = this.statusList[1];
        }

        this._autocompleteService.setValueOnSelect2(null, "funcionario");

        this.queryMovimentacoes();
    }

    getFuncionarioObject(object: any) {
        this.funcionarioSearch = object;
        this.queryMovimentacoes();
    }

    funcionarioTemplateResult = (function(state: any) {
        let template: any = this._funcionarioService.templateResult(state, false);
        return template;
    }.bind(this));

    private queryMovimentacoes() {
        let query: any = {"where":{}};

        let dateStart: any = document.getElementById('data_saida');
        if (dateStart.value) {
            const currDate = this._utilService.convertStringToDate(dateStart.value);
            let nextCurrDate = new Date(currDate.getTime());
            nextCurrDate.setDate(currDate.getDate() + 1);
            let dateQuery = [{dataHoraPrevistaSaida: {"gt": currDate}},{dataHoraPrevistaSaida: {"lt": nextCurrDate}}];

            query.where.and = dateQuery;
            // {"where":{"and":[{"dataHoraPrevistaSaida":{"gt":"2017-02-22T02:00:00.000Z"}},{"dataHoraPrevistaSaida":{"lt":"2017-02-23T02:00:00.000Z"}}]}}
        }

        if (this.tipoSearch.Key) {
            query.where.tipo = this.tipoSearch.Key;
        }

        if (this.statusSearch.Key) {
            if (this.statusSearch.Key === -1) {
                const statusAprovado = this._deslocamentoService.getStatusAprovado();
                const statusSolicitado = this._deslocamentoService.getStatusSolicitado();
                const or = {or: [{status: statusAprovado}, {status: statusSolicitado}]};
                if (query.where.and) {
                    query.where.and.push(or);
                } else {
                    query.where.and = [or];
                }
            } else {
                query.where.status = this.statusSearch.Key;
            }
        }

        if (this.funcionarioSearch.id) {
            query.where.solicitanteId = this.funcionarioSearch.id;
        }

        this.getMovimentacoes(query);
    }

    private getMovimentacoes(query: any) {
        if (this.isVisitor) {
            query.where.usuarioCriacaoId = this.isVisitor;
        }

        this.loading = true;
        this._deslocamentosApiService.onGetByFilter(query, this.onDone);
    }

    private onDone = (function(Response: any) {
        if (!Response.error)  {
            let x: number, lenX: number;
            for (x = 0, lenX = Response.length; x < lenX; x++) {
                Response[x].tipo = this._deslocamentoService.getTipo(Response[x].tipo);
                Response[x].status = this._deslocamentoService.getStatus(Response[x].status);
            }

            this.list = Response;
        }
        this.loading = false;
    }.bind(this));

    private getStatus() {
        let list: any[] = this._utilService.cloneObject(statusDeslocamentos);
        let statusAprovado: any = this._deslocamentoService.getStatusAprovado();
        let statusSolicitado: any = this._deslocamentoService.getStatusSolicitado();

        statusAprovado = this._deslocamentoService.getStatus(statusAprovado);
        statusSolicitado = this._deslocamentoService.getStatus(statusSolicitado);

        list.unshift({Key: -1, Value: 'Ativos ('+ statusAprovado.Value + ' e '+ statusSolicitado.Value + ')'});
        list.unshift({Key: null, Value: '— Status —'});
        this.statusList = list;
    }

    private getTipos() {
        let list: any[] = this._utilService.cloneObject(tiposDeslocamentos);
        list.unshift({Key: null, Value: '— Tipo —'});
        this.tiposList = list;
        this.tipoSearch = this.tiposList[0];
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/deslocamentos/deslocamento-list/deslocamento-list.component.ts
 **/